import { View } from 'foundations-components/components/View';
import { breakpointValues, trellisBreakpoint } from 'pricing-pages-lib/constants/Breakpoints';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import styled from 'foundations-theming/utils';
import { useWindowSize } from '../../hooks/useWindowSize';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MerchCardWrapper = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__MerchCardWrapper",
  componentId: "sc-1pwleyq-0"
})(["display:contents;"]);

/**
 * This is a basic div that will be rendered vertically at 100% under existing grid
 * columns and will display an shadow under it
 */
export const ShadowColumn = ({
  backgroundColor
}) => {
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: backgroundColor || 'fill-surface-default',
    boxShadow: "100",
    blockSize: "100%",
    inlineSize: "100%",
    borderWidth: "100",
    borderStyle: "solid",
    borderColor: "border-core-subtle",
    borderRadius: "100",
    "aria-hidden": "true"
  });
};
const ShadowColumns = ({
  columns
}) => {
  const cols = [];
  for (let i = 0; i < columns; i++) {
    cols.push( /*#__PURE__*/_jsx(ShadowColumn, {
      "aria-hidden": "true"
    }, `shadow-column-${i}`));
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: cols
  });
};
export const MerchCardShadowColumns = ({
  columns,
  children,
  shadowColumnsComponent
}) => {
  const windowSize = useWindowSize();
  const defaultGridProps = {
    gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
    columnGap: columns > 2 ? '400' : '1400',
    maxInlineSize: columns > 2 ? 'initial' : `calc(100% / 3 * ${columns})`,
    inlineSize: '100%',
    insetInlineStart: '0',
    insetInlineEnd: '0',
    marginInline: 'auto'
  };
  const sdMacGridProps = {
    columnGap: columns > 2 ? '0' : '400',
    maxInlineSize: 'initial',
    marginBlockStart: '400'
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PPUIGrid, Object.assign({
      position: "relative"
    }, defaultGridProps, windowSize.width < breakpointValues.sdMac ? sdMacGridProps : {}, {
      children: children
    })), /*#__PURE__*/_jsx(PPUIGrid, Object.assign({
      "aria-hidden": "true",
      blockSize: "100%",
      position: "absolute",
      insetBlockStart: "0",
      zIndex: "-1"
    }, defaultGridProps, windowSize.width < breakpointValues.sdMac ? sdMacGridProps : {}, {
      children: shadowColumnsComponent || /*#__PURE__*/_jsx(ShadowColumns, {
        columns: columns
      })
    }))]
  });
};
export const MerchCardTitleContainer = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__MerchCardTitleContainer",
  componentId: "sc-1pwleyq-1"
})(({
  theme
}) => {
  return {
    display: 'flex',
    alignItems: 'start',
    gap: theme.space[200],
    blockSize: '100%',
    [trellisBreakpoint.sdMac]: {
      flexDirection: 'column',
      justifyContent: 'end'
    }
  };
});